import AttributeIcon from "csi/middleware/attributes/AttributeIcon";
import { OverflowText, FlexRowCenter } from "designSystem/index";
import React, { CSSProperties, FC, ReactElement } from "react";
import css from "./CustomViewAttributes.module.css";
import CustomViewAttribute from "./CustomViewAttribute";

interface AttributeDragPreviewProps {
	/** attribute */
	attribute: CustomViewAttribute;
}

export const AttributeDragPreview: FC<AttributeDragPreviewProps> = ({
	attribute,
}): ReactElement => {
	return (
		<fieldset
			className={css.attribute}
			style={{
				background: "var(--PrimaryWhite)",
				boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
				width: 272,
				zIndex: 1001,
			}}
		>
			<legend>
				<OverflowText maxWidth={200} text={attribute.container.name} />
			</legend>
			<FlexRowCenter justifyContent="space-between">
				<FlexRowCenter gap={2}>
					<AttributeIcon spec={attribute.spec} />
					<OverflowText
						lineHeight={14}
						maxWidth={140}
						semiBold
						text={attribute.spec.name}
					/>
				</FlexRowCenter>
			</FlexRowCenter>
		</fieldset>
	);
};